import React, { useEffect, useState } from 'react';
import api from '../services/api';

// Icono de reloj (SVG) reutilizable para los botones de "Historial".
export const ClockIcon = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width={size} height={size} strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
);

// Modal con la línea de tiempo (bitácora) de un documento genérico.
// Uso: <DocHistorialModal docTipo="ot" docId={id} numero="OT-2026-0001" onClose={...} />
const ICONO = {
  creacion:  <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></>,
  estado:    <><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></>,
  dian:      <><path d="M3 21h18"/><path d="M5 21V7l7-4 7 4v14"/><path d="M9 21v-6h6v6"/></>,
  email:     <><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></>,
  pago:      <><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></>,
  contable:  <><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></>,
  nota:      <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
  entregada: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></>,
  anulada:   <><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></>,
};
const COLOR = { creacion:'#22c55e', estado:'#3b82f6', dian:'#8b5cf6', email:'#3b82f6', pago:'#10b981', contable:'#f59e0b', nota:'#fb923c', anulada:'#ef4444' };

export default function DocHistorialModal({ docTipo, docId, numero, onClose }) {
  const [eventos, setEventos] = useState(null);

  useEffect(() => {
    api.get(`/historial/${docTipo}/${docId}`)
      .then(r => setEventos(Array.isArray(r.data) ? r.data : []))
      .catch(() => setEventos([]));
  }, [docTipo, docId]);

  const fmtFecha = (d) => {
    const f = new Date(d);
    return f.toLocaleDateString('es-CO', { day:'2-digit', month:'short', year:'numeric' })
      + ' · ' + f.toLocaleTimeString('es-CO', { hour:'2-digit', minute:'2-digit' });
  };

  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.modal} onClick={e => e.stopPropagation()}>
        <div style={s.header}>
          <div>
            <h2 style={{ ...s.title, display:'flex', alignItems:'center', gap:8 }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>
              Historial del documento</h2>
            {numero && <p style={s.sub}>{numero}</p>}
          </div>
          <button style={s.close} onClick={onClose}>✕</button>
        </div>

        <div style={s.body}>
          {eventos === null && <p style={s.muted}>Cargando…</p>}
          {eventos !== null && eventos.length === 0 && <p style={s.muted}>Sin eventos registrados.</p>}
          {eventos && eventos.length > 0 && (
            <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
              {eventos.map((ev, i) => {
                const color = COLOR[ev.tipo] || '#64748b';
                const isLast = i === eventos.length - 1;
                return (
                  <div key={ev.id} style={{ display:'flex', gap:10, position:'relative' }}>
                    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', flexShrink:0, width:24 }}>
                      <div style={{ width:24, height:24, borderRadius:'50%', background:'#0f172a', border:`2px solid ${color}`, display:'flex', alignItems:'center', justifyContent:'center', zIndex:1, color }}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12" strokeLinecap="round" strokeLinejoin="round">{ICONO[ev.tipo] || <circle cx="12" cy="12" r="2.5" fill="currentColor" stroke="none"/>}</svg>
                      </div>
                      {!isLast && <div style={{ width:2, flex:1, background:'#334155', minHeight:8 }} />}
                    </div>
                    <div style={{ flex:1, paddingBottom: isLast ? 0 : 10, minWidth:0 }}>
                      <div style={{ color:'#e2e8f0', fontSize:12, lineHeight:1.35 }}>{ev.descripcion}</div>
                      <div style={{ color:'#64748b', fontSize:10, marginTop:1 }}>
                        {fmtFecha(ev.created_at)}{ev.usuario ? ` · ${ev.usuario}` : ''}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div style={s.footer}><button style={s.btn} onClick={onClose}>Cerrar</button></div>
      </div>
    </div>
  );
}

const s = {
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200, padding:20 },
  modal:   { background:'#1e293b', borderRadius:16, width:'100%', maxWidth:520, maxHeight:'85vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  header:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', padding:'18px 22px', borderBottom:'1px solid #334155' },
  title:   { color:'#f1f5f9', fontSize:17, fontWeight:700, margin:0 },
  sub:     { color:'#64748b', fontSize:12, margin:'3px 0 0', fontFamily:'ui-monospace,monospace' },
  close:   { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer', lineHeight:1 },
  body:    { padding:'18px 22px', overflowY:'auto', flex:1 },
  muted:   { color:'#475569', fontSize:13, textAlign:'center', padding:'16px 0' },
  footer:  { padding:'14px 22px', borderTop:'1px solid #334155', display:'flex', justifyContent:'flex-end' },
  btn:     { background:'#334155', color:'#e2e8f0', border:'none', borderRadius:8, padding:'8px 18px', fontSize:13, cursor:'pointer' },
};
